<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:class="modalSize"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/schedule-recommendation/${inputs.id}`
						: `transaction/schedule-recommendation`
				"
			>
				
				<div class="form-group row align-items-center">
					<label for="inputs_academic_calendar_id" class="col-sm-3 mb-0">
						Semester
					</label>
					
					<app-input
						id="inputs_academic_calendar_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_academic_calendar_id"
						@input="setAcademicCalendarId"
						fetch-url="master/academic-calendar"
						placeholder="Semester"
						list-value-field="academic_calendar_name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center" >
					<label for="inputs_product_id" class="col-sm-3 mb-0">
						Product Name
					</label>
					<app-input
						id="inputs_product_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_product"
						@input="setProductValue"
									fetch-url="master/product?product_category_exclude=3,2"
						placeholder="Product Name"
						list-value-field="name"
  						:disabled="isEditMode"
						required
					/>
				</div>
				
				<div class="form-group row align-items-center" >
					<label for="inputs_packages_name" class="col-sm-3 mb-0">
						Package Name
					</label>
					<app-input
						id="inputs_packages_name"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_packages_name"
						@input="setPackagesNameValue"
						:fetch-url="inputs.product_id ? `master/list-packages?product_id=${inputs.product_id}` : ''"
						placeholder="Packages Name"
						list-value-field="package_name"
						:disabled="isEditMode"
						required
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_mon" class="col-sm-3 mb-0"> Mon </label>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_1"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_1"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_tue" class="col-sm-3 mb-0"> Tue </label>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_2"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_2"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_wed" class="col-sm-3 mb-0"> Wed </label>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_3"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_3"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_thu" class="col-sm-3 mb-0"> Thu </label>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_4"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_4"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_fri" class="col-sm-3 mb-0"> Fri </label>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_5"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_5"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sat" class="col-sm-3 mb-0"> Sat </label>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_6"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_6"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sun" class="col-sm-3 mb-0"> Sun </label>
					<app-input
						id="inputs_sun"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_7"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_sun"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_7"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_date_start" class="col-sm-3 mb-0">
						Start Date
					</label>
					<app-input
						id="inputs_date_start"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_start"
						placeholder="Start Date"
						:disabled="isCourseDateStartExist"
					/>
				</div> -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_date_end" class="col-sm-3 mb-0">
						End Date
					</label>
					<app-input
						id="inputs_date_end"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_end"
						placeholder="End Date"
					/>
				</div> -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_date_clc_start" class="col-sm-3 mb-0">
						CLC Date Start
					</label>
					<app-input
						id="inputs_date_clc_start"
						class="col-sm-9"
						type="text"
						v-model="inputs.date_clc_start"
						placeholder="CLC Date Start"
						:disabled="isCourseDateClcStartExist"
					/>
				</div> -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_date_clc_end" class="col-sm-3 mb-0">
						CLC Date End
					</label>
					<app-input
						id="inputs_date_clc_end"
						class="col-sm-9"
						type="text"
						v-model="inputs.date_clc_end"
						placeholder="CLC Date End"
					/>
				</div> -->
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "AssignScheduleSecondForm",
	inject: ["eventHub"],
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		clcIdNumber: String,
		assignScheduleId: {
			type: Number,
		},
		value: {
			type: Object,
			default: () => {
				return {
					name: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			modalId: this.formId,
			modalTitle: this.$t("add"),
			modalSize: "fullscreen",
			input_academic_calendar_id : {},
			inputs: {
				clc_id_number: this.clcIdNumber,
				time_start_1: "",
				time_start_2: "",
				time_start_3: "",
				time_start_4: "",
				time_start_5: "",
				time_start_6: "",
				time_start_7: "",
				time_end_1: "",
				time_end_2: "",
				time_end_3: "",
				time_end_4: "",
				time_end_5: "",
				time_end_6: "",
				time_end_7: "",
			},
			isEditMode: false,
			isCourseDateStartExist: true,
			isCourseDateClcStartExist: true,
    		input_packages_name: {},  
			courseScheduleLists: [],
      		input_product: {},
			input_course_id: this.value
				? this.value
					? {
							id: this.value.id || 0,
							course_name: this.value.course_name || "",
							product_id: this.value.product_id || "",
					  }
					: {
							id: this.value?.id || 0,
							course_name: this.value?.course_name || "",
							product_id: this.value?.product_id || "",
					  }
				: {
						id: this.value.id || 0,
						course_name: this.value.course_name || "",
						product_id: this.value.product_id || "",
				  },
			input_course_schedule_id: this.value
				? this.value
					? {
							id: this.value.id || 0,
							course_schedule_name:
								this.value.course_schedule_name || "",
							day_id: this.value.day_id?.id || "",
							course_group_id:
								this.value.course_group_id?.id || "",
					  }
					: {
							id: this.value?.id || 0,
							course_schedule_name:
								this.value?.course_schedule_name || "",
							day_id: this.value?.day_id?.id || "",
							course_group_id:
								this.value?.course_group_id?.id || "",
					  }
				: {
						id: this.value.id || 0,
						course_schedule_name:
							this.value.course_schedule_name || "",
						day_id: this.value.day_id?.id || "",
						course_group_id: this.value.course_group_id?.id || "",
				  },
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		async fetchCourseSchedule() {
			try {
				let time_start = this.input_course_schedule_id.time_start.slice(
					0,
					-3
				);
				let time_end = this.input_course_schedule_id.time_end.slice(
					0,
					-3
				);

				if (
					this.input_course_schedule_id?.day_id?.day_name === "Monday"
				) {
					this.inputs.time_start_1 = time_start;
					this.inputs.time_end_1 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Tuesday"
				) {
					this.inputs.time_start_2 = time_start;
					this.inputs.time_end_2 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Wednesday"
				) {
					this.inputs.time_start_3 = time_start;
					this.inputs.time_end_3 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Thursday"
				) {
					this.inputs.time_start_4 = time_start;
					this.inputs.time_end_4 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name === "Friday"
				) {
					this.inputs.time_start_5 = time_start;
					this.inputs.time_end_5 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Saturday"
				) {
					this.inputs.time_start_6 = time_start;
					this.inputs.time_end_6 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name === "Sunday"
				) {
					this.inputs.time_start_7 = time_start;
					this.inputs.time_end_7 = time_end;
				}
			} catch (error) {
				console.error("Error fetching course schedule data:", error);
			}
		},
		submit() {
			this.inputs.date_start = this.formattedDate(this.inputs.date_start);
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
			this.eventHub.$emit("assignScheduleSecondFormSuccessCreateData");
		},
		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			if(response.data.invoice_id){
				if(response.data.invoice_id.academic_calendar){
					this.inputs.academic_calendar_id = response.data.invoice_id.academic_calendar_id;
					this.input_academic_calendar_id = response.data.invoice_id.academic_calendar;
				}
			}

			if (
				response.data.schedule_recommendations &&
				response.data.schedule_recommendations.length > 0
			) {
				this.inputs.time_start_1 = response.data.schedule_recommendations[0].time_start_1;
				this.inputs.time_end_1 = response.data.schedule_recommendations[0].time_end_1;
				this.inputs.time_start_2 = response.data.schedule_recommendations[0].time_start_2;
				this.inputs.time_end_2 = response.data.schedule_recommendations[0].time_end_2;
				this.inputs.time_start_3 = response.data.schedule_recommendations[0].time_start_3;
				this.inputs.time_end_3 = response.data.schedule_recommendations[0].time_end_3;
				this.inputs.time_start_4 = response.data.schedule_recommendations[0].time_start_4;
				this.inputs.time_end_4 = response.data.schedule_recommendations[0].time_end_4;
				this.inputs.time_start_5 = response.data.schedule_recommendations[0].time_start_5;
				this.inputs.time_end_5 = response.data.schedule_recommendations[0].time_end_5;
				this.inputs.time_start_6 = response.data.schedule_recommendations[0].time_start_6;
				this.inputs.time_end_6 = response.data.schedule_recommendations[0].time_end_6;
				this.inputs.time_start_7 = response.data.schedule_recommendations[0].time_start_7;
				this.inputs.time_end_7 = response.data.schedule_recommendations[0].time_end_7;
			}


			let product = {
				id: null,
				name: null,
				code: null,
				is_active: null
			}
			
			if (response.data.product_id?.id) {
				this.isEditMode = true;
				product = {
					id: response.data.product_id.id,
					name: response.data.product_id.name,
					code: response.data.product_id.code,
					is_active: response.data.product_id.is_active
				};
				this.setProductValueEditData(product,response.data.invoice_id.package_name);
			}
			
			this.preloader = false;
		},
		setAcademicCalendarId(data) {
			this.inputs.academic_calendar_id = data.id;
			this.input_academic_calendar_id = data;
		},
		resetCourseId() {
			this.input_course_id = {
				id: 0,
				course_name: "",
				product_id: "",
			};
		},
		resetCourseSchedule() {
			this.inputs.time_start_1 = "";
			this.inputs.time_end_1 = "";
			this.inputs.time_start_2 = "";
			this.inputs.time_end_2 = "";
			this.inputs.time_start_3 = "";
			this.inputs.time_end_3 = "";
			this.inputs.time_start_4 = "";
			this.inputs.time_end_4 = "";
			this.inputs.time_start_5 = "";
			this.inputs.time_end_5 = "";
			this.inputs.time_start_6 = "";
			this.inputs.time_end_6 = "";
			this.inputs.time_start_7 = "";
			this.inputs.time_end_7 = "";
		},
		async setPackagesNameValue(selectedPackage) {
			this.inputs.package_name = selectedPackage.package_name;
			
			// Jika package punya id, ambil data detail-nya dari API
			if (selectedPackage?.id) {
				try {
					const res = await axios.get(`/master/packages/name/${selectedPackage.package_name}/${inputs.product_id}`);
					const data = res.data;
					
				   	for (let i = 1; i <= 7; i++) {
						this.inputs[`time_start_${i}`] = "";
						this.inputs[`time_end_${i}`] = "";
					}

					if (Array.isArray(data.course_list_packages)) {
						data.course_list_packages.forEach(item => {
							const day = item.course?.day;
							const timeStart = item.course?.time_start;
							const timeEnd = item.course?.time_end;

							// kalau day valid (1–7)
							if (day >= 1 && day <= 7) {
								this.inputs[`time_start_${day}`] = timeStart ? timeStart.slice(0, 5) : "";
								this.inputs[`time_end_${day}`] = timeEnd ? timeEnd.slice(0, 5) : "";
							}
						});
					}
					
  					this.$forceUpdate();
				} catch (err) {
					console.error("Gagal mengambil data package:", err);
				}
			}
		},
		setProductValueEditData(data,package_name){

			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "product_id", data.id);
			}
						
			this.inputs.product_id = data?.id || null;

			this.$set(this, "input_product", data);

			this.fetchPackagesByProduct(this.inputs.product_id,package_name);

		},
		setProductValue(data) {

			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "product_id", data.id);
			}
						
			this.inputs.product_id = data?.id || null;

			// reset package kalau product tidak ada
			if (!this.inputs.product_id) {
				this.input_packages_name = {};
				this.inputs.package_name = null;
				return;
			}

			this.$set(this, "input_product", data);
			// fetch package list berdasarkan product id
			this.fetchPackagesByProduct(this.inputs.product_id);
			// this.resetCourseId();
			// this.resetCourseSchedule();
		},
		
		async fetchPackagesByProduct(productId,package_name='') {
			try {
				const res = await axios.get("/master/list-packages", {
					params: { product_id: productId }
				});

				// assign data ke dropdown packages
				const packages = res.data.data || [];

				// kalau cuma ada 1 package, langsung pilih otomatis
				if (packages.length === 1) {
					
					this.input_packages_name = packages[0];
					this.inputs.package_name = packages[0].package_name;
					
					try {
						const res = await axios.get(`/master/packages/name/${packages[0].package_name}/${productId}`);
						const data = res.data;
						
						for (let i = 1; i <= 7; i++) {
							this.inputs[`time_start_${i}`] = "";
							this.inputs[`time_end_${i}`] = "";
						}

						if (Array.isArray(data.course_list_packages)) {
							data.course_list_packages.forEach(item => {
								const day = item.course?.day;
								const timeStart = item.course?.time_start;
								const timeEnd = item.course?.time_end;

								// kalau day valid (1–7)
								if (day >= 1 && day <= 7) {
									this.inputs[`time_start_${day}`] = timeStart ? timeStart.slice(0, 5) : "";
									this.inputs[`time_end_${day}`] = timeEnd ? timeEnd.slice(0, 5) : "";
								}
							});
						}
						
						this.$forceUpdate();
					} catch (err) {
						console.error("Gagal mengambil data package:", err);
					}
				} else {
					
					if(package_name !=''){
						const selectedPackage = packages.find(p => p.package_name === package_name);
  						this.input_packages_name = selectedPackage;
						this.inputs.package_name = package_name;
						
						try {
							const res = await axios.get(`/master/packages/name/${package_name}/${productId}`);
							const data = res.data;
							
							for (let i = 1; i <= 7; i++) {
								this.inputs[`time_start_${i}`] = "";
								this.inputs[`time_end_${i}`] = "";
							}

							if (Array.isArray(data.course_list_packages)) {
								data.course_list_packages.forEach(item => {
									const day = item.course?.day;
									const timeStart = item.course?.time_start;
									const timeEnd = item.course?.time_end;

									// kalau day valid (1–7)
									if (day >= 1 && day <= 7) {
										this.inputs[`time_start_${day}`] = timeStart ? timeStart.slice(0, 5) : "";
										this.inputs[`time_end_${day}`] = timeEnd ? timeEnd.slice(0, 5) : "";
									}
								});
							}
							
							this.$forceUpdate();
						} catch (err) {
							console.error("Gagal mengambil data package:", err);
						}
					}else{
						this.input_packages_name = {};
						this.inputs.package_name = null;
					}
				}
			} catch (err) {
				console.error("Gagal ambil package:", err);
				this.input_packages_name = {};
				this.inputs.package_name = null;
			}
		},
		setCourseIdValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.inputs.course_id = data.id;
				this.inputs.product_id =
					data.product_id || this.inputs.product_id;

				this.isCourseDateStartExist = Boolean(data.course_date_start);
				this.inputs.date_start = this.isCourseDateStartExist
					? data.course_date_start
					: null;

				this.isCourseDateClcStartExist = Boolean(
					data.course_date_clc_start
				);
				this.inputs.date_clc_start = this.isCourseDateClcStartExist
					? data.course_date_clc_start
					: null;
			}
		},
		setCourseScheduleIdValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.inputs.course_schedule_id = data.id;
				this.inputs.course_group_id =
					data.course_group_id?.id ||
					this.$toast.e("Course Group ID is not found");
			}
			this.resetCourseSchedule();
			this.fetchCourseSchedule();
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
};
</script>
